module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "intro-dedication-text"
  }, [_vm._v("In loving memory of my mother Paula Lee Wilcox")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("September 2, 1952–September 7, 2006")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenPageitem-8",
    attrs: {
      "alt": "My Mother",
      "src": "image/Image1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552f4b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781630472863_EPUB-2.vue
// module id = 66
// module chunks = 0